import React from 'react';
import styled from '@benzinga/themetron';

export interface BenzingaStaticsBlockProps {
  attrs?: {
    data?: {
      stats: string;
      stats_title: string;
      period: string;
    }[];
  };
}

export const BenzingaStaticsBlock = ({ attrs }: BenzingaStaticsBlockProps) => {
  const count = attrs?.data?.length ?? 2;
  return (
    <BenzingaStaticsBlockContainer className="why-benzinga-block-container" count={count}>
      {Array.isArray(attrs?.data) && attrs?.data?.length && (
        <div className="why-benzinga-block-statistics-wrapper">
          {attrs?.data?.map((card, i) => (
            <div className="why-benzinga-block-card-wrapper" key={i}>
              <div className="why-benzinga-block-card-value">{card.stats}</div>
              <div className="why-benzinga-block-card-title">{card.stats_title}</div>
              <div className="why-benzinga-block-period">{card.period}</div>
            </div>
          ))}
        </div>
      )}
    </BenzingaStaticsBlockContainer>
  );
};

const BenzingaStaticsBlockContainer = styled.div<{ count: number }>`
  &.why-benzinga-block-container {
    display: flex;
    padding: 48px 1.5rem;

    @media screen and (max-width: 1439px) {
      padding: 48px 1.5rem;
    }

    @media screen and (max-width: 959px) {
      padding: 48px 1.5rem;
      flex-direction: column;
      gap: 48px;
    }

    @media screen and (max-width: 781px) {
      padding: 18px 0;
      flex-direction: column;
      gap: 48px;
    }

    @media screen and (max-width: 567px) {
      padding: 10px 0;
    }
  }

  .why-benzinga-block-content-wrapper {
    flex: 1 1 50%;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .why-benzinga-block-title {
    max-width: 554px;
  }

  .why-benzinga-block-subtitle {
    max-width: 382px;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #192940;
  }

  .why-benzinga-block-text {
    max-width: 390px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #5b7292;
  }

  .why-benzinga-block-statistics-wrapper {
    flex: 1 1 50%;
    display: grid;
    grid-auto-columns: 1fr;
    grid-template-columns: repeat(${({ count }) => `${count}`}, 1fr);
    grid-gap: 16px;
    align-items: flex-end;

    @media screen and (max-width: 567px) {
      grid-template-columns: 1fr;
      grid-gap: 32px;
      align-items: unset;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .why-benzinga-block-card-value {
    font-family: 'Rubik', sans-serif;
    font-weight: 700;
    font-size: 48px;
    line-height: 56px;
    text-transform: uppercase;
    color: #3f83f8;
    @media screen and (max-width: 781px) {
      font-size: 38px;
      line-height: 44px;
    }
  }

  .why-benzinga-block-card-title {
    margin-top: 8px;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    text-transform: uppercase;
    color: #192940;
    @media screen and (max-width: 567px) {
      margin-top: 4px;
    }
  }

  .why-benzinga-block-period {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #5b7292;
  }
`;

BenzingaStaticsBlock.defaultProps = {
  attrs: {
    data: {
      statistics: [
        {
          period: 'per month',
          title: 'impressions',
          value: '150M+',
        },
        {
          period: 'per month',
          title: 'page views',
          value: '45M+',
        },
      ],
      subtitle: 'Benzinga is a content ecosystem that makes information easier to consume.',
      text: 'Our mission is to connect the world with news, data, and education that makes the path to financial prosperity easier for everyone – every day.',
      title: 'Why Benzinga?',
    },
  },
};
